import constants from "../static/constants.json";
import dayjs from "dayjs";
export const clearLocalStorage = () => {
  localStorage.setItem("token", "");
  localStorage.setItem("token_type", "");
};

export const addressToString = (a: any) => {
  return `${a.street1} ${a.street2 ? ", " + a.street2 : ""}`;
};

export const addressToStringFull = (a: any) => {
  return `${a.street1} ${a.street2 ? ", " + a.street2 : ""} ${a.city} ${
    a.state
  } ${a.zip}`;
};

export const timeToDayShort = (time: string) => {
  return dayjs(time).format("ddd, MMM D");
};

export const timeToTimeOfDayShort = (time: string) => {
  return dayjs(time).format("h:mm A");
};

export const getJobTypeName = (typeId: string): string => {
  switch (typeId) {
    case constants.jobType.landscaping:
      return "Landscaping";
    case constants.jobType.maintenance:
      return "Maintenance";
    case constants.jobType.cleaning:
      return "Housekeeping";

    default:
      return "";
  }
};

export const getActionWordFromTypeId = (typeId: string): string => {
  switch (typeId) {
    case constants.eventType.created:
      return "Posted by";
    case constants.eventType.assigned:
      return "Assigned to";
    case constants.eventType.completed:
      return "Finished by";
    case constants.eventType.started:
      return "Started by";
    case constants.eventType.requested:
      return "Requested by";
    case constants.eventType.accepted:
      return "Approved by";
    case constants.eventType.rejected:
      return "Rejected by";
    case constants.eventType.cancelled:
      return "Cancelled by";
    default:
      return "Unknown action";
  }
};

export const getJobStatusName = (statusId: string): string => {
  switch (statusId) {
    case constants.jobStatus.open:
      return "Available";
    case constants.jobStatus.assigned:
      return "Assigned";
    case constants.jobStatus.started:
      return "Started";
    case constants.jobStatus.completed:
      return "Complete";
    case constants.jobStatus.accepted:
      return "Approved";
    case constants.jobStatus.rejected:
      return "Rejected";
    case constants.jobStatus.reported:
      return "Reported";
    case constants.jobStatus.cancelled:
      return "Cancelled";

    default:
      return "Unknown Status";
  }
};

export const getPropertyTypeName = (typeId: string): string => {
  switch (typeId) {
    case constants.propertyType.apartment:
      return "Apartment";
    case constants.propertyType.house:
      return "House";
    case constants.propertyType.condo:
      return "Condo";
    default:
      return "Unknown property type";
  }
};

export const getEventTextFromTypeId = (typeId: string): string => {
  switch (typeId) {
    case constants.eventType.created:
      return "Posted by";
    case constants.eventType.assigned:
      return "accepted your job request";
    case constants.eventType.completed:
      return "completed a job";
    case constants.eventType.started:
      return "started a job";
    case constants.eventType.accepted:
      return "approved your work";
    case constants.eventType.rejected:
      return "rejected your work";
    case constants.eventType.requested:
      return "requested a job";
    case constants.eventType.cancelled:
      return "cancelled a job";
    default:
      return "did something unknown";
  }
};

export const getUserPhotoSrc = (userId: string) => {
  return `https://storage.googleapis.com/${process.env.REACT_APP_PHOTOS_BUCKET}/users/${userId}.png`;
};

export const extractNumbersFromString = (input: string): string => {
  return input.replace(/[^0-9]/gi, "");
};

export const getAPIErrorString = (e: any) => {
  if (e.response && e.response.data && e.response.data.message) {
    return e.response.data.message;
  } else return "Unkown API error";
};
